
import { RETRY_EXECUTION_MODAL_KEY } from '../constants';
import Vue from 'vue';
import { restApi } from '@/components/mixins/restApi';
import mixins from 'vue-typed-mixins';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';

import {
	IWorkflowDataUpdate,
	IWorkflowSettings,
} from '../Interface';

import Modal from './Modal.vue';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import moment from 'moment';

export default mixins(
	restApi,
	workflowHelpers,
).extend({
	name: 'RetryExecutionModal',
	components: {
		Modal,
		ModalButtonSuccess,
		ModalButtonCancel,
	},
	props: {
		dataModal: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			modalBus: new Vue(),
			RETRY_EXECUTION_MODAL_KEY,
			activeRetryExecutionOriginal: false,
			activeRetryExecutionRecent: false,
		};
	},
	computed: {
		executionId() {
			return this.dataModal?.executionId || this.$store.getters.activeExecutionId;
		},
		workflowVersaoPublicadaId() {
			return this.dataModal?.workflowVersaoPublicadaId || null;
		},

	},
	mounted () {

	},
	methods: {
		async retryExecution () {
			const loadWorkflow = this.activeRetryExecutionRecent ? true : false;

			if (loadWorkflow && !this.workflowVersaoPublicadaId) {
				this.$store.commit('activeAlert', {
					message: 'Não foi possível reprocessar a versão mais recente do fluxo pois ela não possui uma versão publicada.',
					status: 'error',
				});
				return;
			}

			try {
				const retrySuccessful = await this.restApi().retryExecution(this.executionId, loadWorkflow);

				if (retrySuccessful === true) {

					this.$store.commit('setActiveExecutionId', null);
					this.modalBus.$emit('close');

					this.$store.commit('activeAlert', {
						message: loadWorkflow ? this.$locale.baseText('retryExecutionModal.initRetryRecent') : this.$locale.baseText('retryExecutionModal.initRetryOriginal'),
					});
				} else {
					this.$store.commit('activeAlert', {
						message: this.$locale.baseText(
							'executionsList.showMessage.retrySuccessfulFalse.message',
						),
						status: 'error',
					});
				}
			} catch (error) {
				this.$store.commit('activeAlert', {
					message: this.$locale.baseText('executionsList.showError.retryExecution.message'),
					status: 'error',
				});
			}
			
			
		},
		activeCard(second) {
			if (second) {
				this.activeRetryExecutionOriginal = true;
				this.activeRetryExecutionRecent = false;
			} else {
				this.activeRetryExecutionOriginal = false;
				this.activeRetryExecutionRecent = true;
			}
		},
	},
});
